import {Image, View} from '@react-pdf/renderer'
import {styles} from './Styles'
import logo from '../../icons/prismIcon.png'
import healthPrismLogo from '../../icons/HealthPrism.png'
import peoplePrismLogo from '../../icons/PeoplePrism.png'
import PropTypes from 'prop-types'

const PrismLogo = ({prismProgram}) => {
  const prismLogo = prismProgram === 'PeoplePrism' ? peoplePrismLogo : healthPrismLogo
  return <Image style={{height: '20px', paddingTop: '8px', marginLeft: '8px'}} src={prismLogo} />
}

PrismLogo.propTypes = {
  prismProgram: PropTypes.string
}

const PDFLogo = ({prismProgram = 'HealthPrism'}) => (
  <View style={styles.logoContainer}>
    <Image style={{height: '60px'}} src={logo} />
    <PrismLogo prismProgram={prismProgram} />
  </View>
)

PDFLogo.propTypes = {
  prismProgram: PropTypes.string
}

export default PDFLogo
